import { render, staticRenderFns } from "./Research.vue?vue&type=template&id=1a00f018&scoped=true"
import script from "./Research.vue?vue&type=script&lang=js"
export * from "./Research.vue?vue&type=script&lang=js"
import style0 from "./Research.vue?vue&type=style&index=0&id=1a00f018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a00f018",
  null
  
)

export default component.exports